// Here, tableKey must be of type "CIMPRESS://cimpress.eu-west-1.usage/tables_ranked_by_queries"
export default function tableKeyToCluster(tableKey) {
  const clusterWithSchema = tableKey.split('/')[2];
  const cluster = clusterWithSchema.split('.').slice(0, 2).join('.');
  return cluster;
}
